import {CreateElement} from "../Utilities/CreateElement";
import {userConfiguration} from "../../config";
import {taskManager} from "../globals";
import {DraggableWindow} from "./DraggableWindow";

export type DesktopEntryType = "file" | "folder" | "app";

export interface DesktopEntry {
    name: string;
    icon: string;
    type: DesktopEntryType;
    url: string;
}

export class Desktop {
    dom: HTMLElement;

    constructor() {
        this.dom = CreateElement(`
<div class="row row-cols-auto bg-transparent pt-2 ps-3" style="flex: 1;">
</div>`);

        userConfiguration.DesktopEntryProvider().map(entry => {
            this.addIcon(entry);
        })
    }

    addIcon(entry: DesktopEntry) {
        const div = CreateElement(`
<div class="col rounded-2 m-2 desktop-entry">
    <img src="${entry.icon}" class="mx-auto d-block" style="height: 45px; width: auto;" alt="${entry.name}"/>
    <p class="bg-light rounded-2 px-1 mt-1 text-center">${entry.name}</p>
</div>
`);
        div.addEventListener('click', () => {
            const window = new DraggableWindow({
                title: entry.name,
                id: entry.name,
                icon: entry.icon,
                url: entry.url,
            });
            const task = taskManager.addTask(window);
            window.onclose = (force: boolean): boolean => {
                taskManager.removeTask(task.id);
                return false;
            };

        });
        this.dom.appendChild(div);
    }

    render(container: HTMLElement) {
        const parent = CreateElement(`
        <div class="container-fluid"></div>
        `);
        parent.appendChild(this.dom);
        container.appendChild(parent);
    }
}